import React from 'react'
import PanelHead from '../../UI/Panel/PanelHead';
import PanelBody from '../../UI/Panel/PanelBody';
import { EmailTemplateTable } from '../../UI/EmailTemplates/EmailTemplateTable';

const EmailTemplates = () => {
  return (
    <div>
      <PanelHead title="Email Templates" />
      <PanelBody content={<EmailTemplateTable />} />
    </div>
  )
}

export default EmailTemplates;